export const APPLY_FILTERS = 'ZORSE_APPLY_FILTERS';
export const CLEAR_FILTERS = 'ZORSE_CLEAR_FILTERS';
export const CLEAR_SEARCH_TERMS = 'ZORSE_CLEAR_SEARCH_TERMS';
export const ENTER_SEARCH_TERMS = 'ZORSE_ENTER_SEARCH_TERMS';
export const CLEAR_TICKETS = 'ZORSE_CLEAR_TICKETS';
export const SEARCH_TICKETS = 'ZORSE_SEARCH_TICKETS';
export const SEARCH_MORE_TICKETS = 'ZORSE_SEARCH_MORE_TICKETS';
export const FETCH_FILTER_OPTIONS = 'ZORSE_FETCH_FILTER_OPTIONS';